import React from "react";
import CoreAutoComplete from "../../../app/core/components/CoreAutoComplete/CoreAutoComplete";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import StudioFilter from "../../../app/core/components/UserFilter/StudioFilter";

export const FormSection = ({ title, fields, isEqualHeadquartersCheckbox }) => {
  return (
    <div className="w-full p-8 shadow-md rounded-xl">
      <h5 className="my-0">{title}</h5>
      <>{isEqualHeadquartersCheckbox}</>
      {fields
        .reduce((rows, field, index) => {
          if (index % 2 === 0) rows.push([]);
          rows[rows.length - 1].push(field);
          return rows;
        }, [])
        .map((row, rowIndex) => (
          <div key={rowIndex} className="flex w-full space-x-4">
            {row.map((field, fieldIndex) => {
              return field.type === "select" ? (
                <CoreAutoComplete
                  key={fieldIndex}
                  name={field.name}
                  common={field.value}
                  label={field.label}
                  onChange={field.onChange}
                  fetchData={field.fetch}
                  className={field.className}
                  error={field.error}
                />
              ) : //ATECO
              field.type === "coreSelectObjArr" ? (
                <div className="flex  mt-4">
                  <CoreSelectObjArr
                    name={field.name}
                    label={field.label}
                    value={field.value}
                    items={field?.items}
                    onChange={field.onChange}
                    required={field.required}
                    className={field.className}
                    error={!!field.error}
                    helperText={field.error}
                    disabled={field.disabled}
                  />
                </div>
              ) : field.type === "selectStudio" ? (
                <StudioFilter
                  selectedUser={field.value}
                  setSelectedUser={field.onChange}
                  usersList={field.items}
                  setDebouncedInputUserValue={field.setDebouncedValue}
                  isError={field.error}
                  className={field.className}
                />
              ) : field.type === "emptyDiv" ? (
                <div className={field.className}></div>
              ) : (
                <CoreInputField
                  InputLabelProps={{ shrink: Boolean(field.value) }}
                  disabled={field.disabled}
                  key={fieldIndex}
                  label={field.label}
                  type={field.type}
                  name={field.name}
                  value={field.value}
                  onChange={field.onChange}
                  required={field.required}
                  error={Boolean(field.error)}
                  helperText={field.error}
                  className={field.className}
                />
              );
            })}
          </div>
        ))}
    </div>
  );
};
